"use client";

import Search from "@/components/home-search";
type SearchProps = {
	searchParams: { [key: string]: string | string[] | undefined };
	title: string;
};
export const SearchHeader = ({ searchParams, title }: SearchProps) => {
	return (
		<div>
			<div className="p-4 mt-4 gap-y-4 flex flex-col text-center s-results-header">
				<div className="flex flex-col items-center w-full">
					<Search searchParams={searchParams} searchTitle={title} />
				</div>
			</div>
		</div>
	);
};
